/**
 * Utility functions for RPC (Rewards Points Accelerator) code conversions
 */

/**
 * RPC codes that get 50% bonus (1.5x value)
 */
const RPC_CODES_50 = ['0544', '0545', '0550', '0552', '0511', '0518', '0519', '0512'];

/**
 * RPC codes that get 25% bonus (1.25x value)
 */
const RPC_CODES_25 = ['0444', '0551', '0477', '0514', '0515', '0484', '0486', '0535', '0536'];

/**
 * RPC codes that get 10% bonus (1.1x value)
 */
const RPC_CODES_10 = ['0516', '0419', '0475', '0309', '0540', '0404', '0534', '0509', '0533'];

/**
 * Converts an RPC code to its numeric percentage value
 * @param rpcCode - The 4-digit RPC code (e.g., '0544', '0444', '0516')
 * @returns The numeric percentage (10, 25, 50) or 0 if invalid/not provided
 */
export function rpcCodeToPercentage(rpcCode?: string | null): number {
  if (!rpcCode || typeof rpcCode !== 'string') return 0;

  // Safety check: ensure rpcCode is a 4-digit string
  if (!/^\d{4}$/.test(rpcCode)) {
    return 0;
  }

  if (RPC_CODES_50.includes(rpcCode)) {
    return 50;
  }
  if (RPC_CODES_25.includes(rpcCode)) {
    return 25;
  }
  if (RPC_CODES_10.includes(rpcCode)) {
    return 10;
  }

  return 0;
}

/**
 * Converts an RPC code to a formatted percentage string
 * @param rpcCode - The 4-digit RPC code (e.g., '0544', '0444', '0516')
 * @param defaultValue - The default value to return if code is invalid (default: '0%')
 * @returns The formatted percentage string (e.g., '10%', '25%', '50%')
 */
export function rpcCodeToPercentageString(rpcCode?: string | null, defaultValue = '0%'): string {
  if (!rpcCode) return defaultValue;

  const percentage = rpcCodeToPercentage(rpcCode);
  return percentage > 0 ? `${percentage}%` : defaultValue;
}
